// 存储数据，当天结束时失效
export const setLocalStorageWithDailyExpiry = (key, value, expiryTime) => {
    // 获取当天结束的时间戳（本地时间）
    const endOfDay = new Date();
    let expiryTimestamp;
    if (expiryTime === 'twoMinutes') {
        // 获取当前时间并添加2分钟
        expiryTimestamp = endOfDay.getTime() + 2 * 60 * 1000; 
    } else {
        // 设置为当天的23:59:59.999
        endOfDay.setHours(23, 59, 59, 999);
        expiryTimestamp = endOfDay.getTime();
    }

    // 创建存储对象，包含值和过期时间
    const item = {
        value: value,
        expiry: expiryTimestamp,
    };

    // 存储到localStorage
    localStorage.setItem(key, JSON.stringify(item));
};

// 获取数据，自动处理过期
export const getLocalStorageWithDailyExpiry = (key) => {
    const itemStr = localStorage.getItem(key);
    
    // 如果不存在则返回null
    if (!itemStr) return null;

    // 解析存储对象
    const item = JSON.parse(itemStr);
    const now = new Date().getTime();

    // 检查是否过期
    if (now > item.expiry) {
        localStorage.removeItem(key); // 过期则删除
        return null;
    }

    return item.value; // 返回有效值
};

/**
 * 清除所有订单相关的缓存数据
 * 包括：
 * 1. cacheOrderSummaryCache - 运输中订单和已分派订单的缓存
 * 2. importantOrderSummaryCache - 闪测订单和争议/差评订单的缓存
 * 3. orderSummaryCache - 已超期订单、即将超期订单、待回收订单、待上传结果订单的缓存
 */
export const clearOrderSummaryCache = () => {
  localStorage.removeItem('cacheOrderSummaryCache');
  localStorage.removeItem('importantOrderSummaryCache');
  localStorage.removeItem('orderSummaryCache');
};
